<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <router-link class="navbar-brand mr-3" to="/">{{ $t('nav.appName') }}</router-link>

    <ul class="navbar-nav">
      <router-link class="nav-item" tag="li" to="/management">
        <a class="nav-link">{{ $t('nav.questionFormManagement') }}</a>
      </router-link>
    </ul>

    <div class="ml-auto align-self-center">
      <v-popover>
        <div class="user-info">
          <Icon name="account-circle" class="mr-1 text-muted" />
          {{ name }}
        </div>

        <template v-slot:popover>
          <div class="user-roles">
            <div class="title">{{$t('nav.roles')}}</div>
            <ul>
              <li v-for="role in roles" :key="role">{{ role }}</li>
            </ul>
          </div>
        </template>
      </v-popover>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('user', ['name', 'roles']),
  },
};
</script>

<style lang="scss" scoped>
.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.user-roles {
  text-align: left;

  .title {
    margin-bottom: 0.25rem;
    font-size: 1rem;
    font-weight: bold;
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
}
</style>
